import "./contact.css";
import SEO from "../../SEO";

/* ── Data ──────────────────────────────────────────────────────────────────── */
const contactInfo = [
  {
    icon: (
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
        <circle cx="12" cy="10" r="3" />
      </svg>
    ),
    label: "Location",
    value: "Mahabubnagar, Telangana, India",
  },
];

const inquiries = [
  "Project Discussions",
  "Product Demos",
  "Partnership Opportunities",
  "Custom Solutions",
  "Technical Support",
  "Maintenance Queries",
];

const supportItems = [
  "Technical support",
  "Maintenance queries",
  "Issue reporting",
];

/* ── Form delivery ──────────────────────────────────────────────────────────
   The form opens the visitor's own mail client with everything pre-filled and
   addressed to CONTACT_EMAIL. No API key and no third-party service — the
   send happens from the visitor's own account.

   Trade-off worth knowing: the message only reaches you if the visitor
   actually presses Send in their mail client, and someone with no mail client
   configured (common on desktop) will see nothing happen. The address is also
   shown in the sidebar so it can always be copied manually.
   ──────────────────────────────────────────────────────────────────────── */
const CONTACT_EMAIL = "sales@bestcodetechnology.com";

/* ── Component ─────────────────────────────────────────────────────────────── */
export default function Contact() {
  return (
    <>
      <SEO
        title="Contact Us: Start an AI Project | Best Code Technology"
        description="Get in touch about AI products, SaaS platforms, or custom engineering. We reply within one business day."
        keywords="contact AI company, AI project enquiry, software development contact"
        url="https://bestcodetechnology.in/about/contact"
      />
      <div className="ct-page">
        {/* ══════════════════════════════════════════
          HERO
      ══════════════════════════════════════════ */}
        <section className="ct-hero">
          <div className="container-xl">
            <div className="row justify-content-center">
              <div className="col-12 col-md-10 col-lg-8 text-center">
                <div className="ct-hero__eyebrow">
                  <span className="ct-tag ct-tag--muted">Contact Us</span>
                </div>

                <h1 className="ct-hero__headline">
                  Let's Build Something
                  <br />
                  <span>Great Together</span>
                </h1>

                <p className="ct-hero__desc">
                  We're here to help with your ideas, projects, and business
                  needs. Reach out anytime — we respond within one business day.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* ══════════════════════════════════════════
          MAIN — form + sidebar
      ══════════════════════════════════════════ */}
        <section className="ct-main">
          <div className="container-xl">
            <div className="row g-5 align-items-start">
              {/* Email is the whole ask now, so it gets the full width and
                  sits centred rather than rattling around in a 7-column
                  slot that was sized for a six-field form. */}
              <div className="col-12">
                <div className="ct-reach">
                  <p className="ct-reach__label">Get in touch</p>
                  <h2 className="ct-reach__title">
                    Tell us what you're building
                  </h2>
                  <p className="ct-reach__sub">
                    Email us and we'll reply within one business day.
                  </p>

                  <a className="ct-mail-cta" href={`mailto:${CONTACT_EMAIL}`}>
                    <span className="ct-mail-cta__icon" aria-hidden="true">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                        <polyline points="22,6 12,13 2,6" />
                      </svg>
                    </span>
                    <span className="ct-mail-cta__value">{CONTACT_EMAIL}</span>
                  </a>
                </div>
              </div>

              {/* ── Sidebar ── */}
              <div className="col-12">
                <div className="ct-sidebar">
                  {/* contact info */}
                  <div className="ct-info-card">
                    <p className="ct-info-card__label">Contact Information</p>
                    <h3 className="ct-info-card__title">
                      We'd Love to Hear From You
                    </h3>
                    <ul className="ct-info-list">
                      {contactInfo.map((item) => (
                        <li key={item.label} className="ct-info-item">
                          <div className="ct-info-item__icon">{item.icon}</div>
                          <div>
                            <p className="ct-info-item__label">{item.label}</p>
                            <p className="ct-info-item__value">{item.value}</p>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* business inquiries */}
                  <div className="ct-inq-card">
                    <p className="ct-inq-card__label">Business Inquiries</p>
                    <h3 className="ct-inq-card__title">How Can We Help?</h3>
                    <div className="ct-inq-grid">
                      {inquiries.map((item) => (
                        <div key={item} className="ct-inq-item">
                          {item}
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* support */}
                  <div className="ct-support-card">
                    <p className="ct-support-card__label">Support</p>
                    <h3 className="ct-support-card__title">
                      Need Technical Help?
                    </h3>
                    <ul className="ct-support-list">
                      {supportItems.map((item) => (
                        <li key={item} className="ct-support-item">
                          <span
                            className="ct-support-item__dot"
                            aria-hidden="true"
                          />
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
